import { Creator } from "./Checklist";

export type Comment = {
  id: string;
  type: CommentType;
  message: string;
  poster: Creator;
  listId: string | null;
  orderId: string | null;
  postedAt: string;
};

export const MAX_MESSAGE_LENGTH = 1000;

export type CommentType = "INTERNAL_COMMENT" | "EXTERNAL_COMMENT" | "ADDITIONAL_EQUIPMENT";
